import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorReaderPipe } from './error-reader.pipe';

@NgModule({
  declarations: [ErrorReaderPipe],
  imports: [CommonModule],
  exports: [ErrorReaderPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ErrorReaderModule {}
